// extracted by mini-css-extract-plugin
module.exports = {"list":"Tags_list__5U0TT"};